// [S-492] Industry talent-tier labels for the template / brief "tier" field.
//
// The stored value reuses the AccessTier enum (basic/professional/enterprise) as
// the deal's talent tier, but "Basic / Professional / Enterprise" reads like a
// product plan, not a talent tier — which is exactly the confusion Bill flagged.
// So the UI surfaces industry terms (Scale → A-list → A+/A++) while the stored
// value is unchanged. The genuine product accessTier (feature gating, Settings)
// is a SEPARATE concept and is NOT relabeled.
export type TalentTier = "basic" | "professional" | "enterprise";

const LABELS: Record<TalentTier, string> = {
  basic: "Scale", // day players / scale performers
  professional: "A-list",
  enterprise: "A+ / A++", // marquee / top-of-market
};

/** Ordered options for talent-tier pickers/filters. */
export const TALENT_TIERS: ReadonlyArray<{ value: TalentTier; label: string }> = [
  { value: "basic", label: LABELS.basic },
  { value: "professional", label: LABELS.professional },
  { value: "enterprise", label: LABELS.enterprise },
];

/** Display label for a stored tier value; passes unknown values through. */
export function talentTierLabel(tier: string): string {
  return LABELS[tier as TalentTier] ?? tier;
}
